import { render, staticRenderFns } from "./CarrierPortal.vue?vue&type=template&id=1842ed4e&"
import script from "./CarrierPortal.vue?vue&type=script&lang=js&"
export * from "./CarrierPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports